import { z } from "zod/v4";

import { validateWithSchema } from "@/helpers/common";
import { formatString } from "@/helpers/formatting";
import { metadataSchema } from "@/schemas/metadata";

import { axiosClient } from "../client";
import endpoints from "../endpoints";

import type {
  Metadata,
  MetadataInput,
  MetadataPayload,
} from "@/schemas/metadata";

export interface GetMetadataParams {
  model_type: string;
  model_id: string;
}

class MetadataApiService {
  async list({ model_type, model_id }: GetMetadataParams): Promise<Metadata[]> {
    const { data } = await axiosClient.get<{ data: Metadata[] }>(
      endpoints.METADATA.ALL,
      { params: { model_type, model_id } }
    );
    return validateWithSchema(z.array(metadataSchema), data.data);
  }

  async create(payload: MetadataPayload): Promise<Metadata> {
    const { data } = await axiosClient.post<{ data: Metadata }>(
      endpoints.METADATA.ALL,
      payload
    );
    return validateWithSchema(metadataSchema, data.data);
  }

  async update({
    metadataId,
    payload,
  }: {
    metadataId: number;
    payload: Partial<MetadataInput>;
  }): Promise<Metadata> {
    const url = formatString(endpoints.METADATA.SINGLE, metadataId);
    const { data } = await axiosClient.put<{ data: Metadata }>(url, payload);
    return validateWithSchema(metadataSchema, data.data);
  }

  async delete(metadataId: number): Promise<void> {
    const url = formatString(endpoints.METADATA.SINGLE, metadataId);
    await axiosClient.delete(url);
  }
}

export default new MetadataApiService();
